import { world } from '../../languages';

export const getIsLowestPrice = (material: Material) => {
    const materialWorld = (material?.world || world).toUpperCase();

    const pricesArray = Array.isArray(material.prices) ? material.prices : null;
    const pricesRecord = !Array.isArray(material.prices)
        ? (material.prices as unknown as Record<string, PricesItem>)
        : null;

    const isLowestPriceInRecord =
        //@ts-ignore
        pricesRecord?.[materialWorld]?.isLowestPrice || pricesRecord?.[materialWorld]?.is_lowest_price;

    const isLowestPriceInArray =
        pricesArray?.find((p) => p?.country?.toUpperCase() === materialWorld)?.isLowestPrice ||
        //@ts-ignore
        pricesArray?.find((p) => p?.country?.toUpperCase() === materialWorld)?.is_lowest_price;
    //@ts-ignore
    const isLowestPriceInObject = material.isLowestPrice || material.is_lowest_price;

    return isLowestPriceInObject ?? isLowestPriceInRecord ?? isLowestPriceInArray;
};
